// extracted by mini-css-extract-plugin
export default {"container":"Du5s1","full_width":"fReM6","full_height":"KrEJq"};